import { ActionTree } from 'vuex';

import { DirectionService } from '@/shared/services';
import { localeService } from '@/shared/services/locale/localeService';
import { i18n } from '@/i18n';
import { MutationTypes, IRootState } from './types';
import { DEFAULT_DIRECTION, DEFAULT_LOCALE } from '@/modules/login/shared/store/constants';
import { getStaticSource } from '@/modules/login/services/resources-service';

const actions: ActionTree<IRootState, any> = {
  moduleRegistered({ commit }, moduleName: string) {
    commit(MutationTypes.MODULE_REGISTERED, moduleName);
  },

  async initAccess({ commit }) {
    commit(MutationTypes.SET_LOCALE, i18n.global.locale);
  },

  setLocale({ commit }, locale = DEFAULT_LOCALE) {
    commit(MutationTypes.SET_LOCALE, locale || i18n.global.locale);
  },

  setDirection({ commit }, direction = DEFAULT_DIRECTION) {
    commit(MutationTypes.SET_DIRECTION, direction);
    DirectionService.set(direction);
  },

  setHideIgentifyLogo({ commit }, hideIgentifyLogo = false) {
    commit(MutationTypes.SET_HIDE_IGENTIFY_LOGO, hideIgentifyLogo);
  },

  async getTranslations({ commit }, locale = 'en') {
    const translations = await getStaticSource(`/ui-assets/access-ui/consent/precon/${locale}.json`);

    i18n.global.locale = locale;
    localeService.addTranslation(locale, translations);

    return translations;
  },

  setIsLoggedIn({ commit }, isLoggedIn = false) {
    commit(MutationTypes.SET_IS_LOGGED_IN, isLoggedIn);
  },

  setSupportsLandscapeWarning({ commit }, supportsLandscapeWarning = false) {
    commit(MutationTypes.SET_SUPOORTS_LANDSCAPE_WARNING, supportsLandscapeWarning);
  },
};

export default actions;
